var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "formatter" }, [
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("TimezonePickerInput", {
          attrs: { title: "From Timezone" },
          model: {
            value: _vm.clone.isWeekday.fromTimezone,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isWeekday, "fromTimezone", $$v)
            },
            expression: "clone.isWeekday.fromTimezone",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("FormatPickerInput", {
          attrs: { title: "From Format" },
          model: {
            value: _vm.clone.isWeekday.fromFormat,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isWeekday, "fromFormat", $$v)
            },
            expression: "clone.isWeekday.fromFormat",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex gap-5 groups" },
      [
        _c("LocalePickerInput", {
          attrs: { title: "From Locale" },
          model: {
            value: _vm.clone.isWeekday.fromLocale,
            callback: function ($$v) {
              _vm.$set(_vm.clone.isWeekday, "fromLocale", $$v)
            },
            expression: "clone.isWeekday.fromLocale",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex gap-5" }, [
      _c("div", { staticClass: "editor-row customize-editor-minimize" }, [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Weekday Days"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "weekday-days" },
          [
            _c(
              "a-checkbox-group",
              {
                model: {
                  value: _vm.clone.isWeekday.weekdayDays,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.isWeekday, "weekdayDays", $$v)
                  },
                  expression: "clone.isWeekday.weekdayDays",
                },
              },
              [
                _c("a-checkbox", { attrs: { value: "1" } }, [_vm._v("Monday")]),
                _vm._v(" "),
                _c("a-checkbox", { attrs: { value: "2" } }, [
                  _vm._v("Tuesday"),
                ]),
                _vm._v(" "),
                _c("a-checkbox", { attrs: { value: "3" } }, [
                  _vm._v("Wednesday"),
                ]),
                _vm._v(" "),
                _c("a-checkbox", { attrs: { value: "4" } }, [
                  _vm._v("Thursday"),
                ]),
                _vm._v(" "),
                _c("a-checkbox", { attrs: { value: "5" } }, [_vm._v("Friday")]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }